import { format } from "date-fns";
import { DateOption } from "./types";
import {
  WORK_ITEM_CATEGORIES,
  WorkItemCategory,
} from "../../utils/workItemUtils";

// helpers.ts
export const formatDate = (dateString?: string | null): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("sv-SE", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const calculateDueDate = (
  dateOption: DateOption,
  customDate: string | null,
  selectedAction?: string | null
): string => {
  const today = new Date();
  let dueDate: Date;
  dueDate = new Date(today);
  const isFollowUp = WORK_ITEM_CATEGORIES[WorkItemCategory.FOLLOWUP].includes(
    Number(selectedAction)
  );

  if (isFollowUp) {
    dueDate.setHours(12, 0, 0, 0); // Set to noon for follow-ups
  } else {
    dueDate.setHours(17, 0, 0, 0); // Default to end of day
  }
  if (dateOption === "tomorrow") {
    dueDate.setDate(today.getDate() + 1);
  } else if (dateOption === "week") {
    dueDate.setDate(today.getDate() + 7);
  } else {
    dueDate = customDate ? new Date(customDate) : new Date();
  }
  return format(dueDate, "yyyy-MM-dd'T'HH:mm:ss");
};

export const createDefaultScheduledDate = (selectedAction?: string | null) => {
  const isFollowUp = WORK_ITEM_CATEGORIES[WorkItemCategory.FOLLOWUP].includes(
    Number(selectedAction)
  );
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (isFollowUp) {
    tomorrow.setHours(12, 0, 0, 0); // Set to noon for follow-ups
    return format(tomorrow, "yyyy-MM-dd'T'HH:mm:ss");
  }
  tomorrow.setHours(17, 0, 0, 0);
  return format(tomorrow, "yyyy-MM-dd'T'HH:mm:ss");
};
